import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const newChildCareDataForm: Form<Child> = {
  key: 'newChidlCareData',
  title: 'Neue Betreuungsform',
  fields: [
    {
      key: 'moveOutTypeOfCare',
      label: 'Art',
      fieldTypes: 'select',
      options: [],
    },
    {
      key: 'moveOutCareAdress',
      label: 'Adresse',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'moveOutCarePhone',
      label: 'Telefon',
      fieldTypes: 'text',
    },
    {
      key: 'moveOutCareNotice',
      label: 'Notiz',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default newChildCareDataForm;
